import { useAtom } from "jotai";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Container } from "styles/Common";
import { darkModeAtom } from "utils/ThemeAtom";
import Icons from "./Icons";
import Text from "./Text";
import gsap from "gsap";
function index() {
  const [darkMode] = useAtom(darkModeAtom);
  const [theme, setTheme] = useState(false);

  useEffect(() => {
    setTheme(darkMode);
  }, [darkMode]);

  useEffect(() => {
    gsap.fromTo(
      ".stacks",
      {
        x: 10,
        y: 10,
        ease: "power3.out",
      },
      {
        x: 0,
        y: 0,
        duration: 10,
        repeat: -1,
        yoyo: true,
        ease: "power3.out",
        stagger: 0.1,
      }
    );

    gsap.fromTo(
      ".stacks.rotate svg",
      {
        rotate: 180,
        ease: "power2.inOut",
      },
      {
        rotate: 0,
        duration: 10,
        repeat: -1,
        yoyo: true,
        ease: "power2.inOut",
        stagger: 0.1,
      }
    );

    gsap.fromTo(
      ".stacks.marquee svg",
      {
        x: -20,
        ease: "power2.inOut",
      },
      {
        x: 20,
        duration: 2,
        yoyo: true,
        repeat: -1,
        ease: "power2.inOut",
      }
    );

    gsap.fromTo(
      ".stacks.heartbeat svg",
      {
        scale: 0.8,
        ease: "power2.inOut",
      },
      {
        scale: 1.2,
        duration: 2,
        yoyo: true,
        repeat: -1,
        ease: "power2.inOut",
      }
    );

    gsap.fromTo(
      ".stacks.skew svg",
      {
        skewX: 8,
        ease: "power2.inOut",
      },
      {
        skewX: -8,
        duration: 2,
        yoyo: true,
        repeat: -1,
        ease: "power2.inOut",
      }
    );

    gsap.fromTo(
      ".stacks.jump svg",
      {
        y: -10,
        ease: "power2.inOut",
      },
      {
        y: 10,
        duration: 2,
        yoyo: true,
        repeat: -1,
        ease: "power2.inOut",
      }
    );
  }, []);

  return (
    <SectionBanner $dark={theme} id="banner">
      <Container>
        <Field>
          <FieldText>
            <Text />
          </FieldText>

          <Icons />
        </Field>
      </Container>
    </SectionBanner>
  );
}

export default index;

const SectionBanner = styled.section<{
  $dark: boolean;
  children?: React.ReactNode;
}>`
  background-image: ${({ $dark }) =>
    $dark
      ? 'url("/img/home/banner-bck-dark.webp")'
      : 'url("/img/home/banner-bck.webp")'};
  background-repeat: no-repeat;
  background-size: cover;
  background-color: var(--white);
`;

const Field = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90vh;
`;

const FieldText = styled.div``;
